import '@modules/group-filters';

export default (ctx, html) => html`
  <group-filters max-level="${ctx['max-level']}" @group-change="${ctx.filterUpdated}" .selected-groups="${ctx.selectedGroups}" .show-reset="${ctx['show-reset']}"></group-filters>
`;
